module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('h2', [_vm._v("Resume")]), _vm._v(" "), (!_vm.currentUser) ? _c('div', [_c('el-button', {
    on: {
      "click": _vm.logInVisible
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.signUpVisible
    }
  }, [_vm._v("注 册")])], 1) : _vm._e(), _vm._v(" "), (_vm.formData.logInVisible) ? _c('LogIn') : _vm._e(), _vm._v(" "), (_vm.formData.signUpVisible) ? _c('SignUp') : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('div', [_c('el-button', [_vm._v(_vm._s(_vm.currentUser.attributes.username))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("退出")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3450be9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topbar/Topbar.vue
// module id = 196
// module chunks = 1